import { render, staticRenderFns } from "./AbstractRadioQuestionView.vue?vue&type=template&id=3c1bedd4&scoped=true&"
import script from "./AbstractRadioQuestionView.vue?vue&type=script&lang=ts&"
export * from "./AbstractRadioQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractRadioQuestionView.vue?vue&type=style&index=0&id=3c1bedd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1bedd4",
  null
  
)

export default component.exports